export default __webpack_public_path__ + "static/media/softsagesRFPCommonTemplate.1c3c5a36.png";